export const NEWTAG = "new";
export const EDITTAG = "edit";
